import { useCallback, useState } from 'react'
import {
  createPolicyTemplateGroup as createPolicyTemplateGroupApi,
  deletePolicyTemplateGroup as deletePolicyTemplateGroupApi,
  fetchPolicyTemplateGroupList as fetchPolicyTemplateGroupListApi,
  updatePolicyTemplateGroup as updatePolicyTemplateGroupApi,
} from '../crud/policyTemplateGroup.crud'

const fetchPolicyTemplateGroupList = async ({ setData, setError, setLoading, policyType }) => {
  setLoading(true)
  setError(null)

  try {
    const response = await fetchPolicyTemplateGroupListApi({ policyType })
    setData(response?.data?.groups ?? [])
  } catch (error) {
    console.error(error)
    setError(true)
  }

  setLoading(null)
}

const createPolicyTemplateGroup = async ({ setError, setLoading, params }) => {
  setLoading(true)
  setError(null)
  let success = true

  try {
    await createPolicyTemplateGroupApi(params)
  } catch (error) {
    success = false
    console.error(error)
    setError(true)
  }

  setLoading(null)

  return success
}

const updatePolicyTemplateGroup = async ({ setError, setLoading, params }) => {
  setLoading(true)
  setError(null)
  let success = true

  try {
    await updatePolicyTemplateGroupApi(params)
  } catch (error) {
    success = false
    console.error(error)
    setError(true)
  }

  setLoading(null)

  return success
}

const deletePolicyTemplateGroup = async ({ setError, setLoading, params }) => {
  setLoading(true)
  setError(null)
  let success = true

  try {
    await deletePolicyTemplateGroupApi(params)
  } catch (error) {
    success = false
    console.error(error)
    setError(true)
  }

  setLoading(null)

  return success
}

const usePolicyTemplateGroup = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [data, setData] = useState(null)

  const createPolicyTemplateGroupCb = useCallback(
    (params) =>
      createPolicyTemplateGroup({
        setError,
        setLoading,
        params,
      }),
    [],
  )

  const updatePolicyTemplateGroupCb = useCallback(
    (params) =>
      updatePolicyTemplateGroup({
        setError,
        setLoading,
        params,
      }),
    [],
  )

  const deletePolicyTemplateGroupCb = useCallback(
    (params) =>
      deletePolicyTemplateGroup({
        setError,
        setLoading,
        params,
      }),
    [],
  )

  const fetchPolicyTemplateGroupListCb = useCallback(
    ({ policyType }) =>
      fetchPolicyTemplateGroupList({
        setData,
        setError,
        setLoading,
        policyType,
      }),
    [],
  )

  const clearPolicyTemplateGroupError = useCallback(() => setError(null), [])

  return {
    loading,
    error,
    data,
    createPolicyTemplateGroup: createPolicyTemplateGroupCb,
    fetchPolicyTemplateGroupList: fetchPolicyTemplateGroupListCb,
    deletePolicyTemplateGroup: deletePolicyTemplateGroupCb,
    updatePolicyTemplateGroup: updatePolicyTemplateGroupCb,
    clearPolicyTemplateGroupError,
  }
}

export default usePolicyTemplateGroup
